module.exports = __webpack_public_path__ + "static/media/study 201028.b30ea8eb.png";